import React from 'react';
import CRUDSection from '../CRUDSection';

function Journals() {
  const config = {
    title: 'Journal',
    tableColumns: ['Image', 'Journal Name', 'ISSN', 'Volume', 'Issue', 'Link', 'Actions'],
    renderForm: (formData, handleInputChange, handleImageChange, isEditing) => (
      <>
        <div className="form-grid">
          <div className="form-group">
            <label>Journal Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name || ''}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>ISSN *</label>
            <input
              type="text"
              name="issn"
              value={formData.issn || ''}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="form-grid">
          <div className="form-group">
            <label>Volume *</label>
            <input
              type="text"
              name="volume"
              value={formData.volume || ''}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Issue *</label>
            <input
              type="text"
              name="issue"
              value={formData.issue || ''}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="form-grid full">
          <div className="form-group">
            <label>Link (optional)</label>
            <input
              type="url"
              name="link"
              value={formData.link || ''}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Image *</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              required={!isEditing}
            />
            <small>Leave blank to keep existing image when updating</small>
          </div>
        </div>
      </>
    ),
    renderRow: (item, handleEdit, handleDelete) => (
      <>
        <td>
          <img src={item.imageUrl} alt={item.name} />
        </td>
        <td>{item.name}</td>
        <td>{item.issn}</td>
        <td>{item.volume}</td>
        <td>{item.issue}</td>
        <td>
          {item.link ? (
            <a href={item.link} target="_blank" rel="noopener noreferrer">
              View
            </a>
          ) : (
            'N/A'
          )}
        </td>
        <td className="table-actions">
          <button className="btn-edit" onClick={() => handleEdit(item)}>
            Edit
          </button>
          <button className="btn-delete" onClick={() => handleDelete(item.id)}>
            Delete
          </button>
        </td>
      </>
    )
  };

  return <CRUDSection category="journals" config={config} />;
}

export default Journals;
